import { Component, computed, inject, input } from '@angular/core';
import { TranslocoModule } from '@ngneat/transloco';
import { ModulesEnum } from '@splitsecondconnect/ultramarine-shared';

import { SectionWrapperComponent } from '../../../../../../shared/components/containers/section-wrapper-container/section-wrapper-container.component';
import { UltraActionButtonComponent } from '../../../../../../shared/components/ultramarine-ui/ultra-action-button/ultra-action-button.component';
import { UltraIconComponent } from '../../../../../../shared/components/ultramarine-ui/ultra-icon/ultra-icon.component';
import { ActiveDirective } from '../../../../../../shared/directives/active.directive';
import { FocusDirective } from '../../../../../../shared/directives/focus.directive';
import { ModalService } from '../../../../../../shared/services/modals.service';
import { VehicleRecordModel } from '../../../models/vehicle-record.model';
import { UpdateOdometerTaskComponent } from '../../../tasks/update-odometer-task/update-odometer-task.component';
import { IonNav } from '@ionic/angular';

@Component({
	selector: 'app-vehicle-actions',
	templateUrl: 'vehicle-actions.component.html',
	imports: [
		SectionWrapperComponent,
		FocusDirective,
		ActiveDirective,
		UltraActionButtonComponent,
		TranslocoModule,
		UltraIconComponent,
	],
})
export class VehicleActionsComponent {
	nav = input<IonNav>();
	isEditMode = input<false>();
	#modalService = inject(ModalService);
	recordData = input<VehicleRecordModel>();

	options = computed(() => {
		return [
			{
				title: 'vehicles|record-drawer|item-title|update-odometer',
				tooltip: `vehicles|record-drawer|item-tooltip|update-odometer`,
				type: 'basic',
				icon: 'straighten',
				disabled: this.isEditMode(),
				function: () => {
					void this.#modalService.showActionModal(
						UpdateOdometerTaskComponent,
						this.recordData().id,
						ModulesEnum.VEHICLES,
						undefined,
						undefined,
						this.nav(),
					);
				},
			},
		];
	});
}
